type Platform = 'sensors'

interface IdataSet {
  index: number | string
}

interface IactItem {
  targetUrl: string
  customUrl: string
}
import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'

export function createTrackConfig() {
  return {
    poizon_venue_component_content_click(platform: Platform, dataSet: IdataSet) {
      if (platform !== 'sensors') return
      const actItem: IactItem = (this as any).props?.propsConfig?.list?.[dataSet.index] || {}
      const component_content_url =
        actItem.targetUrl === '自定义跳转' ? actItem.customUrl : actItem.targetUrl
      return {
        current_page: 82,
        block_type: 68,
        venue_id: (this as any).props.pageId,
        venue_title: document.title,
        component_content_position: +dataSet.index + 1,
        component_content_url,
        poizon_component_type: 'poizon-banner',
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },

    poizon_venue_component_content_exposure(platform: Platform, dataSet: IdataSet) {
      if (platform !== 'sensors') return
      const actItem: IactItem = (this as any).props?.propsConfig?.list?.[dataSet.index] || {}
      const component_content_url =
        actItem.targetUrl === '自定义跳转' ? actItem.customUrl : actItem.targetUrl
      return {
        current_page: 82,
        block_type: 68,
        venue_id: (this as any).props.pageId,
        venue_title: document.title,
        component_content_info_list: JSON.stringify([
          {
            component_content_position: +dataSet.index + 1,
            component_content_url,
            poizon_component_type: 'poizon-banner',
            poizon_channel_id,
          },
        ]),
        SK: window.dw.getSk(),
      }
    },
  }
}
